__turbopack_context__.v({
  "hero": "Hero-module__c8dYoG__hero",
  "heroContent": "Hero-module__c8dYoG__heroContent",
  "heroHeading": "Hero-module__c8dYoG__heroHeading",
  "heroImg": "Hero-module__c8dYoG__heroImg",
  "heroLeft": "Hero-module__c8dYoG__heroLeft",
  "heroRight": "Hero-module__c8dYoG__heroRight",
  "heroSubheading": "Hero-module__c8dYoG__heroSubheading",
  "loading": "Hero-module__c8dYoG__loading",
  "logoImage": "Hero-module__c8dYoG__logoImage",
  "siteIntro": "Hero-module__c8dYoG__siteIntro",
});
